<template>
  <div>
    <vs-card class="email-card">
      <div
        class="text-right mb-2"
        v-if="selected.length > 1 && checkDeletePermission()"
      >
        <div class="bulk_holder">
          <a @click="templateDeletePopup1"> Bulk Delete </a>
        </div>
      </div>

      <div class="flex flex-wrap justify-between items-center">
        <div class="md:w-1/2 w-full p-1">
          <vs-input
            placeholder="Search"
            class="w-full"
            v-model="search"
            @keyup="searchFun"
            style="width: 100%"
          />
        </div>

        <vs-button
          @click="emailSignature = true"
          type="filled"
          v-if="checkCreatePermission()"
          >Create Signature</vs-button
        >
      </div>
      <!-- <vs-button
        v-if="selected.length > 1 && checkDeletePermission()"
        icon-pack="feather"
        style="float: right"
        color="danger"
        icon="icon-trash-2"
        @click="templateDeletePopup1"
        >Bulk Delete1</vs-button
      > -->
      <vs-tabs>
        <vs-tab label="" icon-pack="feather" icon="icon-inbox">
          <ag-grid-vue
            :context="context"
            ref="agGridTable"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            @row-selected="CellvalueSelectDeselect"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="templateList"
            rowSelection="multiple"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            :style="{ minHeight: query_page.limit * 48 + 75 + 'px' }"
            :paginationPageSize="paginationPageSize"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>
          <div>
            <ItemsPerTableDropdown
              tableName="email_signature"
              @change="(pageLimit) => (pageLimitSet = pageLimit)"
            />
            <pagination
              :meta="query_page"
              @page-change="handlePageChange"
              class="cstm_pagination"
              style="float: right"
            />
          </div>
        </vs-tab>
      </vs-tabs>
      <div class="bg-overlay"></div>
    </vs-card>
    <vs-popup title="Please confirm" :active.sync="deletepopupflag">
      <vs-row>
        <span>Are you sure to delete this signature?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="deleteSignature"
          color="danger"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Accept22</vs-button
        >
        <vs-button @click="cancelDeletePopup" type="border">Cancel</vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup title="Please confirm" :active.sync="deletepopupflag1">
      <vs-row>
        <span>Are you sure to delete signatures?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="signatureBulkDelete"
          color="danger"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Accept</vs-button
        >
        <vs-button @click="cancelMultipleDeletePopup" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <div v-if="emailSignature">
      <emailSignaturePopup
        :emailSignature="emailSignature"
        :type="type"
        :signature_details="signature_details"
        @closeEmailTempalatePopup="closeEmailTempalatePopup"
        @closeNfetch="closeNfetch"
      />
    </div>
  </div>
</template>

    <!-- TinyMCE CDN -->
<script src="https://cdn.tiny.cloud/1/dby84f0rwttg363c3yyx0t5jucrrxd2rsclfsoi76uhjy4ez/tinymce/5/tinymce.min.js" referrerpolicy="origin"></script>

  <script>
import emailSignaturePopup from "@/views/pages/email/emailSignaturePopup.vue";

import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import Bell from "./Bell";
import Editor from "@tinymce/tinymce-vue";
import vSelect from "vue-select";
import { contentFileUpload } from "@/api/course-builderapi";
import {
  emailDynamicFieldList,
  emailSignatureList,
  emailTemplateCreate,
  emailSignatureDelete,
  emailTemplateShow,
  emailTemplateEdit,
  platformModuleslist,
  communicationTypeList,
  notifiable_platform_modules,
} from "@/api/email.js";
import { PermissionMiddleware } from "../../../mixins/middleware/PermissionMiddleware";
import Pagination from "@/components/common/pagination";

import ImportBrowseFilesModel from "@/components/common/ImportBrowseFilesModel.vue";
import { GoogleAuthorization } from "@/mixins/common/GoogleAuthorization.js";
import { getRepositoryDetails } from "@/api/message";
import { getUploadedFilesId } from "@/api/assignment-question";
import SignatureActionCell from "./SignatureActionCell.vue";
import CheckboxCellComponent from './components/CheckboxCellComponent'
import { emailSignatureEdit } from '@/api/email'

export default {
  name: "Email",
  components: {
    Bell,
    editor: Editor,
    vSelect,
    Pagination,
    AgGridVue,
    SignatureActionCell,
    emailSignaturePopup,
    CheckboxCellComponent,
  },
  mixins: [PermissionMiddleware, GoogleAuthorization],

  data() {
    return {
      signature_details: null,
      deleteSignatureDetails: {},
      emailSignature: false,
      canDelete: true,
      search: "",
      defaultColDef: {
        suppressMenu: false,
        editable: true,
        sortable: true,
        resizable: true,
        // autoHeight: true
      },
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            "filesIcon",
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          );

          editor.ui.registry.addIcon(
            "gDriveIcon",
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          );

          editor.ui.registry.addButton("gDrive", {
            icon: "gDriveIcon",
            tooltip: "Insert from GDrive",
            onAction: () => {
              this.gDrive(editor);
            },
          });
        },
        height: 500,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          "autolink lists link image charmap print preview anchor",
          "imagetools",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
          "code lists fullscreen",
          "emoticons",
        ],
        menu: "table",
        toolbar:
          "customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
                          table alignleft aligncenter alignright alignjustify | \
                          bullist numlist outdent indent | removeformat | help",
      },
      sorting_obj: {
        field_type: "",
        attribute: "",
        direction: "",
      },
      editorComponent: null,
      file_repository_id: "",
      view_template_data: "",
      role_action_id: "",
      communicationTypeListArr: [],
      platformModuleslistArr: [],
      tinyMceApi: "",
      typeOfEmailTemplate: "",
      editTemplateId: null,
      detailsView: [],
      emailViewSidebar: false,
      emailEditSidebar: false,
      image_url: "",
      deletepopupflag: false,
      deletepopupflag1: false,
      deleteTemplateId: "",
      templateData: {},
      ViewtemplateData: {
        platform_module: "",
        platform_module_action: "",
        subject: "",
        template: "",
        is_default: "",
      },
      emailType: [],
      attachICSFile: [],
      checkBox1: "",
      selected: [],
      log: [],
      emailSidebar: false,
      templateList: [],
      query_page: {
        total: "",
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: "",
      },
      pageLimitSet: null,
      gridApi: {},
      gridOptions: {
        accentedSort: true,
      },
      components: {
        CheckboxCellComponent
      }
    };
  },
  beforeMount() {
    this.context = {
        componentParent: this
    }
  },
  created() {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API;
    const customer_id = localStorage.getItem("customer_id");
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL;
    this.image_url = `${imageUploadUrl}${customer_id}`;
    //checking Permission
    const role_permission = localStorage.getItem("role_permission");
    if (role_permission == 1) {
      this.schoolAdmin = true;
    } else {
      this.schoolAdmin = false;

      this.getModulePermission("Communication", "email");
    }

    this.columnDefs = [
      {
        headerName: "",
        maxWidth: 60,
        field: "isSelected",
        filter: false,
        sortable: false,
        checkboxSelection: (params) => {
          return true;
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true,
      },
      {
        headerName: "Name",
        field: "title",
        maxWidth: 300,
      },
      {
        headerName: "Description",
        field: "desc",
        width: 300,
      },
      {
        headerName: "Default",
        field: "is_default",
        maxWidth: 100,
        cellRendererFramework: Vue.extend(CheckboxCellComponent),
        CellRendererParams: {
          isDefault: (data) => this.isDefault(data)
        }
      },
    ];

    if (this.checkEditPermission() || this.checkDeletePermission()) {
      this.columnDefs.push({
        headerName: "Action",
        field: "action",
        maxWidth: 100,
        sortable: false,
        cellRendererFramework: Vue.extend(SignatureActionCell),
        CellRendererParams: {
          templateEditSidebar: (data) => this.templateEditSidebar(data),
          templateDeletePopup: (data) => this.templateDeletePopup(data),
          signatureMarkAsDefault: (data) => signatureMarkAsDefault(data),
          checkEditPermission: () => this.checkEditPermission(),
          checkDeletePermission: () => this.checkDeletePermission(),
        },
      });
    }
  },
  computed: {
    communicationTypeListArrList() {
      this.communicationTypeListArr = this.communicationTypeListArr.filter(
        (element) => {
          if (element.action_name != "LeadActivity") return element;
        }
      );
      return this.communicationTypeListArr;
    },
    buttonActive() {
      if (
        this.templateData.type_id !== null &&
        this.templateData.template !== "" &&
        this.templateData.subject !== ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.getRepositoryDetails();
    //this.notifiable_platform_modules()
    this.getPlatformModuleslist();
  },
  watch: {
    pageLimitSet() {
      this.handlePageChange(1);
    },
  },
  methods: {
    isDefault(signature_data) {
      return signature_data
    },
    closeEmailTempalatePopup() {
      this.emailSignature = false;
      this.signature_details = null
    },
    closeNfetch() {
      this.emailSignature = false;
      this.signature_details = null
      this.handlePageChange(1);
    },
    searchFun() {
      this.fetchListBySearch(this);
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.handlePageChange(1)
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async sortFun() {
      try {
        const sortState = this.gridOptions.api.getSortModel();
        if (sortState.length >0) {
          this.sorting_obj.field_type ='system'
          this.sorting_obj.attribute = sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort
        } else {
          this.sorting_obj.field_type =''
          this.sorting_obj.attribute = ''
          this.sorting_obj.direction = ''
        }
        this.handlePageChange(1);
      } catch (e) {}
    },
    getSelectedRows() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map((node) => node.data);

      return selectedData;
    },
    onGridReady() {
      this.gridOptions.api.sizeColumnsToFit();
    },
    paginationPageSize() {
      return this.pageLimitSet;
    },
    CellvalueSelectDeselect() {
      this.gridApi = this.gridOptions.api;

      const selectedNodes = this.gridApi.getSelectedNodes();
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes();
        this.selected = selecttedNode.map((node) => node.data);
      } else {
        this.selected = [];
      }
    },
    async getRepositoryDetails() {
      const payload = {
        platform_module_id: "39",
      };
      const customer_id = localStorage.getItem("customer_id");
      const data = await getRepositoryDetails(customer_id, payload);
      //
      //
      this.file_repository_id = data.data.data[0].id;
    },
    gDrive(editor) {
      this.editorComponent = editor;
      this.driveIconClicked();
    },
    getImportFile({ file_id, fileInfo }) {
      fileInfo.forEach((eachFile) => {
        this.editorComponent.insertContent(
          `<img src="${eachFile.file_path}" width="auto" height="auto"/>`
        );
      });
      setTimeout(() => {
        this.isBrowseContent = false;
        this.showSuccessMessage(
          "Success",
          "File Imported Successfully",
          "success"
        );
      }, 0);
    },
    async getUploadFiles(file_id_payload, type = "system") {
      const res = await getUploadedFilesId(file_id_payload);

      // console.log()
      const filesDriveInfo = res.data.data.files;
      if (type === "drive") {
        filesDriveInfo.forEach((eachFile) => {
          if (eachFile.file_type.split("/")[0] === "image") {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            );
          } else if (eachFile.file_type.split("/")[0] === "video") {
            this.editorComponent.insertContent(
              `<video width="200" height="300"<source src="${eachFile.file_path}"</video>`
            );
          } else if (eachFile.file_type.split("/")[0] === "audio") {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            );
          }
        });
        console.log(filesDriveInfo);
      }
    },
    async notifiable_platform_modules() {
      try {
        const { data } = await notifiable_platform_modules();
        // console.log(data)
      } catch (e) {}
    },
    handlePageChange(page) {
      if (!this.pageLimitSet) return;
      this.$vs.loading()
      this.selected.length = 0;
      this.query_page.current_page = page;
      const payload = {
        search: this.search,
      };
      // this.fetchQuestionBankList()
      emailSignatureList(
        this.sorting_obj,
        "email_signature",
        payload,
        localStorage.getItem("customer_id"),
        this.query_page.current_page,
        this.pageLimitSet
      )
        .then((res) => {
          this.templateList = res.data.data.signs;
          this.query_page = res.data.data.meta;
          this.$vs.loading.close()
        })
        .catch((e) => {});
    },
    async getPlatformModuleslist() {
      const data = await platformModuleslist();
      this.platformModuleslistArr = data.data.data.modules_list;
      //
    },
    async getCommunicationTypeList() {
      //this.templateData.type_id = null
      const customer_id = localStorage.getItem("customer_id");
      const data = await communicationTypeList(
        customer_id,
        this.templateData.platform_modules_id
      );

      this.communicationTypeListArr = data.data.data.types;

      this.getCommunicationDynamicField();
      //
    },
    async getCommunicationDynamicField() {
      try {
        //this.templateData.type_id = null
        const customer_id = localStorage.getItem("customer_id");
        const platform_modules_id = this.templateData.platform_modules_id;
        const { data } = await emailDynamicFieldList(
          platform_modules_id,
          customer_id
        );
        this.attachICSFile = data.data.email_dynamic_field_list;
      } catch (e) {
        console.error(e);
      }
    },
    appendCodeToTemplate(field_code) {
      // eslint-disable-next-line no-undef
      tinymce.activeEditor.execCommand("mceInsertContent", false, field_code);
      // this.templateData.template += ` ${field_code}`
      this.$vs.notify({
        title: "Success",
        text: "Code added",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        time: 2000,
      });
    },
    images_upload_handler(blobInfo, success, failure) {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open("POST", this.image_url);

      xhr.upload.onprogress = function (e) {
        progress((e.loaded / e.total) * 100);
      };

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`);
          return;
        }

        const json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location !== "string") {
          failure(`Invalid JSON: ${xhr.responseText}`);
          return;
        }

        success(json.location);
      };

      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        );
      };

      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${JSON.parse(localStorage.getItem("access_token"))}`
      );

      const formData = new FormData();
      formData.append("files[0]", blobInfo.blob(), blobInfo.filename());

      xhr.send(formData);
    },
    example_image_upload_handler(blobInfo, success, failure, progress) {
      const formData = new FormData();
      formData.append("files[0]", blobInfo.blob());

      const data = this.fileupload(formData);

      data
        .then((res) => {
          const locationObject = {
            src: {
              value: {
                location: res,
              },
            },
          };

          const stringify = JSON.stringify(res);
          const parse = JSON.parse(stringify);

          success(parse);
        })
        .catch((error) => {});
    },

    async fileupload(payload) {
      try {
        const customer_id = localStorage.getItem("customer_id");

        const responseImage = await contentFileUpload(customer_id, payload);
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path;
        this.$vs.notify({
          title: "Success",
          text: "Image Uploaded Successfully",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          time: 3000,
        });
        return location;
      } catch (error) {}
    },

    handlcreateSidebar() {
      this.emailSidebar = false;
      this.resetData();
    },
    handleEditSidebar() {
      this.emailEditSidebar = false;
      this.selected.length = 0;
      this.templateData.type_id = null;
      this.templateData.subject = "";
      this.templateData.template = "";
      this.templateData.is_default = "";
    },
    templateEditSidebar(edit_template_Data) {
      this.signature_details = edit_template_Data;

      this.emailSignature = true;
    },
    handleViewSidebar() {
      this.emailViewSidebar = false;
      this.selected.length = 0;
    },
    getSelectedRows() {
      return this.selected;
    },
    resetData() {
      this.templateData.type_id = null;
      this.templateData.subject = "";
      this.templateData.template = "";
      this.templateData.is_default = "";
      this.templateData.platform_modules_id = "";
      this.editTemplateId = null;
    },
    createTemplate() {
      if (this.templateData.is_default === "") {
        this.templateData.is_default = 0;
      }

      if (this.editTemplateId !== null) {
        this.editTemplate();
      } else {
        emailTemplateCreate(
          localStorage.getItem("customer_id"),
          this.templateData
        )
          .then((res) => {
            //
            this.emailSidebar = false;
            this.$vs.notify({
              title: "Success",
              text: "Signature Created Successfully",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
            });

            this.resetData();
            emailSignatureList(
              this.sorting_obj,
              "email_signature",
              payload,
              localStorage.getItem("customer_id"),
              this.query_page.current_page,
              this.pageLimitSet
            )
              .then((res) => {
                this.templateList = res.data.data.signs;
                this.query_page = res.data.data.meta;
              })
              .catch((e) => {});
          })
          .catch((e) => {
            this.$vs.notify({
              title: "Warning",
              text: "Something Went Wrong",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          });
      }
    },
    editTemplate() {
      if (
        this.templateData.is_default === null ||
        this.templateData.is_default === false
      ) {
        this.templateData.is_default = 0;
      }
      emailTemplateEdit(
        localStorage.getItem("customer_id"),
        this.editTemplateId,
        this.templateData
      )
        .then((res) => {
          this.emailSidebar = false;
          this.$vs.notify({
            title: "Success",
            text: "Signature Edited Successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          emailSignatureList(
            this.sorting_obj,
            "email_signature",
            payload,
            localStorage.getItem("customer_id"),
            this.query_page.current_page,
            this.pageLimitSet
          )
            .then((res) => {
              this.templateList = res.data.data.signs;
              this.query_page = res.data.data.meta;
              this.selected.length = 0;
              this.handleEditSidebar();
            })
            .catch((e) => {});
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Warning",
            text: "Something Went Wrong",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
      setTimeout(() => {
        this.editTemplateId = null;
      }, 2000);
    },

    cancelDeletePopup() {
      this.deletepopupflag = false;
      this.selected.length = 0;
    },
    cancelMultipleDeletePopup() {
      this.deletepopupflag1 = false;
      this.selected.length = 0;
    },
    templateDeletePopup(signature) {
      this.deletepopupflag = true;
      this.deleteTemplateId = signature.id;
      this.deleteSignatureDetails = signature
    },
    deleteSignature() {
      if (this.deleteSignatureDetails && this.deleteSignatureDetails.is_default === 1) {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t delete default sigature",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        this.deletepopupflag = false
        return false
      }
      const payload = {
        ids: [this.deleteTemplateId],
      };
      emailSignatureDelete(localStorage.getItem("customer_id"), payload)
        .then((res) => {
          this.$vs.notify({
            title: "Success",
            text: "Signature deleted successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          emailSignatureList(
            this.sorting_obj,
            "email_signature",
            payload,
            localStorage.getItem("customer_id"),
            this.query_page.current_page,
            this.pageLimitSet
          )
            .then((res) => {
              this.templateList = res.data.data.signs;
              this.query_page = res.data.data.meta;
              this.selected.length = 0;
              this.deletepopupflag = false;
            })
            .catch((e) => {});
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Warning",
            text: "Something Went Wrong",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
    },
    templateDeletePopup1() {
      this.deletepopupflag1 = true;
    },
    signatureBulkDelete() {
      const BulkSelected = this.getSelectedRows();
      BulkSelected.filter((x) => {
        if (x.is_default === 1) {
          this.canDelete = false
        }
      })
      if (!this.canDelete) {
        this.$vs.notify({
          title: "Warning",
          text: "Unselect default signature first and then try",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        this.canDelete = true
        this.deletepopupflag1 = false
        return false
      }
      const deleting_ids = [];
      for (let i = 0; i < BulkSelected.length; i++) {
        deleting_ids.push(BulkSelected[i].id);
      }
      const payload = {
        ids: deleting_ids,
      }
      emailSignatureDelete(localStorage.getItem("customer_id"), payload)
        .then((res) => {
          //

          this.$vs.notify({
            title: "Success",
            text: "Signatures deleted successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          this.query_page.current_page = this.query_page.next_page_url
            ? this.query_page.current_page
            : this.query_page.current_page - 1;

          emailSignatureList(
            this.sorting_obj,
            "email_signature",
            payload,
            localStorage.getItem("customer_id"),
            this.query_page.current_page,
            this.pageLimitSet
          )
            .then((res) => {
              this.templateList = res.data.data.signs;
              this.query_page = res.data.data.meta;
              this.deletepopupflag1 = false;
              this.selected.length = 0;
            })
            .catch((e) => {});
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Warning",
            text: "Something Went Wrong",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.emailSidebar = false;
    this.emailViewSidebar = false;
    this.emailEditSidebar = false;
    this.deletepopupflag = false;
    this.deletepopupflag1 = false;
    setTimeout(() => {
      next();
    }, 0);
  },
};
</script>

  <style>
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 1000;
}
.unread {
  background-color: #fff5ec;
  font-weight: 500;
}
.read {
  background-color: transparent !important;
  font-weight: 500;
}
.email-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
}
.email-card {
  position: relative;
}
.compose-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  /* background: #FF9F43 !important; */
  /* box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
}
.email-sidebar .vs-sidebar {
  max-width: 400px;
  margin-top: 107px;
}
.email-sidebar .sidebar-scrollable-form {
  height: calc(100% - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}
.email-form input,
.email-form input:focus {
  border: none !important;
  box-shadow: none;
}
.sub-line {
  border: none !important;
  height: 40px;
}

@media (max-width: 360px) {
  .email-sidebar .vs-sidebar {
    max-width: 100%;
  }
}
.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

.code-hint {
  font-size: 8px;
  font-style: italic;
}
.field_code {
  cursor: pointer;
}
.field_code,
.field_description {
  justify-content: flex-start;
  display: flex;
  align-items: center;
  margin: 0%;
  background: #f6f6f6;
  width: 49% !important;
  word-break: break-all;
  padding: 10px;
  border-radius: 7px;
}
</style>